/**
 * @file   src\messages\validationMessages.ts
 * @brief  This file is responsible for define validation messages.
 * @date   June, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */

export const ErrorMessages = {
    ERR_NETWORK: 'Network error. Please check your connection and try again.',
   
};
